export default "__VITE_PUBLIC_ASSET__e32bbbf2__"